import { Routes } from '@angular/router';
import { authGuard } from '#core';
import { PageNotFoundComponent, ServerErrorComponent, UnauthorizedComponent } from '#components';

export const routes: Routes = [
  {
    canActivateChild: [authGuard],
    path: 'start-work-dones',
    loadChildren: () =>
      import('../features/start-work-done/start-work-dones.routes').then(r => r.START_WORK_DONE_ROUTES),
  },
  {
    canActivateChild: [authGuard],
    path: 'categories',
    loadChildren: () => import('../features/categories/categories.routes').then(r => r.CATEGORIES_ROUTES),
  },
  {
    canActivateChild: [authGuard],
    path: 'admin',
    loadChildren: () => import('../features/admin/admin.routes').then(r => r.ADMIN_ROUTES),
  },

  {
    path: '403',
    component: UnauthorizedComponent,
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '500',
    component: ServerErrorComponent,
  },
  {
    path: '',
    redirectTo: '/start-work-dones',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
